export default __webpack_public_path__ + "static/media/b2c1327f-ab3d-4230-93d7-eee8596e1498.776090a0.woff";